import { render, staticRenderFns } from "./ResumeJob.vue?vue&type=template&id=52c39963&scoped=true&"
import script from "./ResumeJob.vue?vue&type=script&lang=js&"
export * from "./ResumeJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c39963",
  null
  
)

export default component.exports